<template>
  <div class="w-100">
    <div class="accordion">
      <b-card no-body>
        <b-card-header @click="setIsOpen" header-tag="header" role="tab">
          <div class="row">
            <div class="col-6 accordion__title">
              <b-icon
                  icon="arrow-down-short"
                  variant="dark"
              >
              </b-icon>
              <strong>
                {{ $t('modal.segment.registered_rule_title') }}
              </strong>
            </div>
            <div class="d-flex justify-content-end align-items-center col-6 text-right">
              <p v-if="isEdited" class="text-danger mr-5 mb-0">{{ $t('error.segment.segment_is_edited') }}</p>
              <p v-if="v.$invalid && v.$anyDirty" class="text-danger mr-5 mb-0">{{ $t('error.segment.segment_required') }}</p>
              <button @click="destroy" class="btn btn-xs btn-danger delete-translation-btn">{{ $t('btn.segment.delete_segment') }}</button>
            </div>
          </div>
        </b-card-header>
        <b-collapse :visible="isOpen" accordion="registered" role="tabpanel">

          <div style="height: 520px;">
            <div class="row p-4 d-flex justify-content-center align-items-start">
              <div class="col-6">
                <p>{{$t('segment.set_registered')}}</p>
              </div>
              <div class="col-6">
                <multiselect
                    @input="emitSelectedValue('operation')"
                    :state="!v.operation.$dirty ? null :(!v.operation.$error)"
                    v-model="operation"
                    :options="options.operation"
                    track-by="value"
                    label="text"
                    :multiple="false">
                </multiselect>
                <div class="">
                  <p v-if="v.operation.$dirty && v.operation.$invalid" class="text-danger">{{ $t('error.required') }}</p>
                </div>
              </div>
            </div>
            <div v-if="operation.value === 'BETWEEN_DAYS'" class="row p-4">
              <div class="col-6">
                <b-form-group
                    :label="$t('segment.label.choose_segment_days_from')"
                    label-for="daysFrom"
                >
                  <b-form-input v-model="daysFrom" @input="emitSelectedValue('daysFrom')" name="daysFrom" id="daysFrom"></b-form-input>
                  <div class="">
                    <p v-if="v.daysFrom.$dirty && v.daysFrom.$invalid" class="text-danger">{{ $t('error.required') }}</p>
                  </div>
                </b-form-group>
              </div>
              <div class="col-6">
                <b-form-group
                    :label="$t('segment.label.choose_segment_days_from')"
                    label-for="daysTo"
                >
                  <b-form-input v-model="daysTo" @input="emitSelectedValue('daysTo')" name="daysTo" id="daysTo"></b-form-input>
                </b-form-group>
              </div>
            </div>

            <div v-if="operation.value === 'BETWEEN_DATES'" class="row p-4 w-100">
              <div class="col-6">
                <b-form-group
                    :label="$t('segment.label.choose_segment_date_from')"
                    label-for="daysTo"
                >
                  <date-range-picker v-model="dateFrom.startDate"
                                     id="daysTo"
                                     :locale="{firstDay: 1, format: 'yyyy-mm-dd'}"
                                     :auto="false"
                                     :linked="false"
                                     @update="emitSelectedValue('dateFrom')"
                                     style="width: 100%;"
                                     :singleDatePicker="true"
                                     :show-week-numbers="false"
                                     :ranges="false"
                                     :opens="'center'">
                    <template v-slot:input="picker">
                      {{ picker.startDate | dateFormat }}
                    </template>
                  </date-range-picker>
                </b-form-group>
                <div class="">
                  <p v-if="v.dateFrom.$dirty && v.dateFrom.$invalid" class="text-danger">{{ $t('error.required') }}</p>
                </div>
              </div>

              <div class="col-6">
                <b-form-group
                    :label="$t('segment.label.choose_segment_date_to')"
                    label-for="validFrom"
                >
                  <date-range-picker v-model="dateTo.startDate"
                                     :locale="{firstDay: 1, format: 'yyyy-mm-dd'}"
                                     :auto="false"
                                     :linked="false"
                                     @update="emitSelectedValue('dateTo')"
                                     style="width: 100%;"
                                     :singleDatePicker="true"
                                     :show-week-numbers="false"
                                     :ranges="false"
                                     :opens="'center'">
                    <template v-slot:input="picker">
                      {{ picker.startDate | dateFormat }}
                    </template>
                  </date-range-picker>
                </b-form-group>
              </div>
            </div>

            <div class="row pr-4 d-flex justify-content-center align-items-start">
              <div class="col-12">
                <button v-if="isEditType" :disabled="!isEdited" @click="saveEditedRule" class="float-right btn btn-xs btn-success">{{ $t('btn.segment.save_edited_rule') }}</button>
              </div>
            </div>
          </div>
        </b-collapse>
      </b-card>
    </div>
  </div>
</template>

<script>
import {userSegment} from "../../../../common/constants/userSegment";
import Multiselect from "vue-multiselect";
import DateRangePicker from "../../../../components/DateRangePicker/components/DateRangePicker";

export default {
  components: {
    Multiselect,
    DateRangePicker
  },
  props: {
    v: {
      type: Object,
      required: true
    },
    registeredForm: Object,
    isEditType: {
      type: Boolean,
      default: false
    },
    ruleId: {
      type: String,
      default: null,
      required: false
    },
    methodPost: {
      type: Boolean,
      required: false
    }
  },
  computed: {
    isEdited: function () {
      return this.$store.getters[`userSegment/getEditedRule`](userSegment.registered);
    }
  },
  mounted() {
    this.$parent.$on('checkValidation', () => {
      this.v.$touch();
    });

    // POTRZEBNE PRZY EDYCJI
    // if(this.registeredForm.locales.length > 0) {
    //   this.locale = this.registeredForm.locales;
    //   this.operation = this.registeredForm.operation;
    //
    //   this.locale = this.options.localeRule.filter(rule => {
    //     if(this.registeredForm.locale.includes(rule.locale)) {
    //       return rule;
    //     }
    //   });
    // }
  },
  data() {
    return {
      dateFrom: {
        startDate: {}
      },
      dateTo: {
        startDate: {}
      },
      isOpen: false,
      daysFrom: '',
      daysTo: '',
      operation: '',
      options: {
        operation: [
          {value: 'BETWEEN_DATES', text: this.$t('segment.option.between_dates')},
          {value: 'BETWEEN_DAYS', text: this.$t('segment.option.between_days')}
        ]
      }
    }
  },
  methods: {
    saveEditedRule() {
      this.$parent.$emit('editRule', {type: userSegment.registered, ruleId: this.ruleId, methodPost: this.methodPost});
    },
    deleteSegmentRule() {
      this.$parent.$emit('deleteSegmentRule', this.ruleId);
    },
    destroy() {

      const data = {
        component: this,
        rule: userSegment.registered,
        ruleId: this.ruleId
      }

      this.$parent.$emit('removeRegisteredRule', data);
    },
    setIsOpen() {
      if(this.isEditType && !this.isEdited) {
        this.isOpen = !this.isOpen;
        return;
      } else if(this.isEditType && this.isEdited) {
        return;
      }

      this.isOpen = !this.isOpen;
    },
    emitSelectedValue(type) {
      if(this.isEditType) {
        const data = {
          key: userSegment.registered,
          value: true
        }

        this.$store.commit('userSegment/setEditedRule', data);
      }

      this.$parent.$emit('selectedRegistered', {
        type: type,
        operation: this.operation ? this.operation.value : null,
        dateFrom: this.dateFrom.startDate,
        dateTo: this.dateTo.startDate,
        daysFrom: this.daysFrom,
        daysTo: this.daysTo,
      });
    }
  }
}
</script>